<template>
    <el-form ref="form"
        :inline="__config.inline"
        :model="model"
        :rules="rules"
        :size="__config.size"
        :label-width="__config.labelWidth">
        <template v-for="(item, index) in __config.widgets">
            <el-form-item
                :key="index"
                :label="item.label"
                :prop="item.prop"
                v-if="item.type !== 'grid' && (item.attr || model[item.prop])">
                <slot v-if="$slots[`slot-${index}`]" :name="`slot-${index}`"/>
                <form-widget v-else
                    :type="item.type"
                    :value="model[item.prop]"
                    :attr="item.attr"
                    :prompt="item.prompt"
                    @input="val => {handleValueChange(val, item.prop)}">
                </form-widget>
            </el-form-item>
            <!-- 只允许嵌套一层row，表单无限嵌套无意义 -->
            <el-row :key="index"
                v-if="item.type == 'grid'"
                :type="item.layout"
                :gutter="item.gutter ? item.gutter : 0"
                :justify="item.justify ? item.justify : ''"
                :align="item.align ? item.align : ''">
                <el-col v-for="(col, colIndex) in item.columns"
                    :key="colIndex"
                    :span="col.span ? col.span : 24"
                    :offset="col.offset ? col.offset : 0"
                    :push="col.push ? col.push : 0"
                    :pull="col.pull ? col.pull : 0"
                    :xs="col.xs"
                    :sm="col.sm"
                    :md="col.md"
                    :lg="col.lg"
                    :xl="col.xl">
                    <el-form-item
                        v-for="(ii, iiIndex) in col.widgets"
                        :key="iiIndex"
                        :label="ii.label"
                        :prop="ii.prop"
                        v-if="ii.type !== 'grid' && (ii.attr || model[ii.prop])">
                        <slot v-if="$slots[`slot-${index}`]" :name="`slot-${index}`"/>
                        <form-widget v-else
                            :type="ii.type"
                            :value="model[ii.prop]"
                            :attr="ii.attr"
                            :prompt="ii.prompt"
                            @input="val => {handleValueChange(val, ii.prop)}">
                        </form-widget>
                    </el-form-item>
                </el-col>
            </el-row>
        </template>
        <el-form-item v-if="$slots.btns || __config.submit">
            <el-button v-if="__config.submit"
                :type="__config.submit.type"
                :size="__config.submit.size"
                :class="__config.submit.className"
                :style="__config.submit.style"
                @click="submitForm">{{__config.submit.text ? __config.submit.text : '提交'}}
            </el-button>
            <slot name="btns"/>
        </el-form-item>
    </el-form>
</template>

<script>
// import uuidv1 from 'uuid/v1'
import FormWidget from './form-widget'
import {merge} from './utils'
// import { valid } from 'semver'
export default {
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    value: {},
    rules: {}
  },
  watch: {
    config: {
      immediate: true,
      deep: true,
      handler () {
        if (this.config) this.__config = merge(this.__config, this.config)
      }
    },
    value: {
      immediate: true,
      deep: true,
      handler () {
        if (this.value) this.model = this.value
      }
    }
  },
  components: {
    FormWidget
  },
  data () {
    return {
      __config: {
        labelWidth: '150px',
        size: 'small',
        inline: false,
        widgets: []
      },
      model: {}
    }
  },
  methods: {
    handleValueChange (val, prop) {
      this.$set(this.model, prop, val)
      this.$emit('input', this.model)
    },
    validate (callback) {
      this.$refs.form.validate(valid => {
        callback(valid)
      })
    },
    clearValidate () {
      if (this.$refs.form) this.$refs.form.clearValidate()
    },
    /**
         * @description 提交表单前的校验
         * @author yangyu
         */
    async submitForm () {
      if (!this.__config || !this.__config.submit) return
      this.$refs.form.validate(async valid => {
        if (valid) {
          if (this.__config.submit.validator) {
            let pass = await this.__config.submit.validator(this.model)
            this.$forceUpdate()
            if (pass) this.save()
          } else {
            this.save()
          }
        }
      })
    },
    /**
         * @description 保存数据
         * @author yangyu
         */
    save () {
      let api = ''
      if (typeof this.__config.submit.api === 'function') {
        api = this.__config.submit.api(this.model)
      } else {
        api = this.__config.submit.api
      }
      this.submitProcessing = true
      return this.$api(api, this.__config.submit.params())().then(res => {
        this.submitProcessing = false
        if (typeof this.__config.submit.success === 'function') {
          this.__config.submit.success(res)
        } else {
          this.$Message.success('处理成功')
        }
      }).catch(err => {
        this.submitProcessing = false
        if (typeof this.__config.submit.failed === 'function') {
          this.__config.submit.failed(err)
        } else {
          this.alert(err, 'error')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/profile/form.vue